import PropTypes from 'prop-types'
import {useTranslation} from 'react-i18next'

import {formatDateString} from '../../../../utils/formatter'

import {
  SubsectionTitle,
  SubsectionContainer,
  SubsectionAlert,
  SubsectionGroup,
  SubsectionSubtitle,
} from '../../../components/Subsection'

const PayerStatementDetails = ({latestStatement}) => {
  const {t} = useTranslation('customers')

  return (
    <SubsectionContainer data-testid="payer-statement-details">
      <SubsectionGroup>
        <SubsectionTitle title={t('Statements.Details.frequency')} />
        <SubsectionSubtitle>{latestStatement.frequency}</SubsectionSubtitle>
      </SubsectionGroup>
      <SubsectionGroup>
        <SubsectionTitle title={t('Statements.Details.lastSent')} />
        <SubsectionSubtitle>
          {latestStatement.sentAt
            ? formatDateString(latestStatement.sentAt)
            : t('Statements.Details.notApplicable')}
        </SubsectionSubtitle>
      </SubsectionGroup>
      <SubsectionGroup>
        <SubsectionAlert
          text={t('Statements.Details.unpaidInvoicesNotification')}
        />
      </SubsectionGroup>
    </SubsectionContainer>
  )
}

PayerStatementDetails.propTypes = {
  latestStatement: PropTypes.shape({
    frequency: PropTypes.string,
    sentAt: PropTypes.string,
  }).isRequired,
}

export default PayerStatementDetails
